<section class="bu-wrapper">
    <header>
        <h2>{{ 'settingsDialog.businessUnitSettingsHeader' | translate}}</h2>
        <p>
            {{ 'settingsDialog.buManagement.line1Description' | translate}}<br />
            {{ 'settingsDialog.buManagement.line2Description' | translate}}
        </p>
    </header>
    <div style="display:flex">
        <kendo-grid [kendoGridBinding]="gridData" #buGrid kendoGridSelectBy="oid"
            [(selectedKeys)]="mySelection" [pageSize]="20" [pageable]="true" [scrollable]="'scrollable'"
            style="width:100%" [filterable]="'menu'" (edit)="editHandler($event)" (cancel)="cancelHandler($event)"
            (save)="saveHandler($event)" (add)="addHandler()">

            <kendo-grid-column field="oid" [title]="'settingsDialog.buManagement.buId' | translate" [editable]="false"
                [width]="50"></kendo-grid-column>
            <kendo-grid-column field="displayName" [title]="'settingsDialog.buManagement.buDisplayName' | translate"
                [width]="200"></kendo-grid-column>
            <kendo-grid-column field="systemName" [title]="'settingsDialog.buManagement.buName' | translate"
                [width]="200"></kendo-grid-column>
            <kendo-grid-column field="description" [title]="'settingsDialog.buManagement.buDescription' | translate"
                [width]="200"></kendo-grid-column>
            <kendo-grid-column field="logdrive" [title]="'settingsDialog.buManagement.buLogdrive' | translate"
                [width]="200"></kendo-grid-column>
            <kendo-grid-column field="active" editor="boolean"
                [title]="'settingsDialog.buManagement.buActive' | translate" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.active" style="pointer-events: none;">
                </ng-template>
            </kendo-grid-column>
            <kendo-grid-column field="isRole" editor="boolean"
                [title]="'settingsDialog.buManagement.isRole' | translate" [width]="100">
                <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="checkbox" [checked]="dataItem.isRole" style="pointer-events: none;">
                </ng-template></kendo-grid-column>

            <kendo-grid-command-column [width]="130">
                <ng-template kendoGridCellTemplate let-isNew="isNew">
                    <button kendoGridEditCommand [primary]="true">Edit</button>
                    <button kendoGridSaveCommand [disabled]="formGroup?.invalid">
                        {{ isNew ? ('common.add' | translate) : ('common.update' | translate) }}
                    </button>
                    <button kendoGridCancelCommand>
                        {{ 'common.cancel' | translate }}
                    </button>
                </ng-template>
            </kendo-grid-command-column>
        </kendo-grid>
    </div>
</section>
